import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DocumentWorkingCopyDepartmentDialogData {
  departmentName: string;
}

@Component({
  selector: 'app-document-working-copy-department-dialog',
  templateUrl: './document-working-copy-department-dialog.component.html',
  styleUrls: ['./document-working-copy-department-dialog.component.scss'],
  standalone: false,
})
export class DocumentWorkingCopyDepartmentDialogComponent {
  readonly escapedDepartmentName: string;

  constructor(@Inject(MAT_DIALOG_DATA) data: DocumentWorkingCopyDepartmentDialogData) {
    this.escapedDepartmentName = this.escapeHtml(data.departmentName);
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}
